import axios from '@/axios/config'
import Toaster from '@/utils/toaster'

export default {
  namespaced: true,
  state: {
    webviewUrl: null,
    listingIotDevices: [],
    allIotDevices: [],
    publishableKey: null,
    seamComponentUuid: null,
    clientSessionToken: null,
  },
  mutations: {
    updateWebviewUrl(state, payload) {
      state.webviewUrl = payload
    },
    updateListingIotDevices(state, payload) {
      state.listingIotDevices = payload
    },
    updateIotDevices(state, payload) {
      state.allIotDevices = payload
    },
    updatePublishableKey(state, payload) {
      state.publishableKey = payload
    },
    updateSeamComponentUuid(state, payload) {
      state.seamComponentUuid = payload
    },
    updateClientSessionToken(state, payload) {
      state.clientSessionToken = payload
    },
  },
  actions: {
    async getConnectWebview({ commit }, { listing_id }) {
      const { data } = await axios.get(`/api/seam/connect/new`, {
        params: { listing_id },
      })
      const url = data?.payload?.data?.webview?.url
      commit('updateWebviewUrl', url)
    },
    async getListingDevices({ commit }, { listing_id }) {
      const { data } = await axios.get(
        `/api/listings/${listing_id}/iot-devices`
      )
      const devices = data?.payload?.data
      commit('updateListingIotDevices', devices)
    },
    async getAllDevices({ commit }, filters = {}) {
      const { data } = await axios.get(`/api/iot/listing-devices`, {
        params: filters,
      })
      const devices = data?.payload?.data?.devices
      commit('updateIotDevices', devices)
    },
    async updateDevice(
      { commit, dispatch },
      { device_id, listing_id, entry_point, code_prefix, code_suffix }
    ) {
      const payload = { device_id }

      if (listing_id !== null && listing_id !== undefined) {
        payload.listing_id = listing_id
      }

      if (entry_point !== null && entry_point !== undefined) {
        payload.entry_point = entry_point
      }

      if (code_prefix !== null && code_prefix !== undefined) {
        payload.code_prefix = code_prefix
      }

      if (code_suffix !== null && code_suffix !== undefined) {
        payload.code_suffix = code_suffix
      }

      await axios.patch(`/api/iot/listing-devices`, payload)
      await dispatch('getAllDevices')
    },
    async getPublishableKey({ commit }) {
      const { data } = await axios.get(`/api/iot/seam-keys`)
      commit('updatePublishableKey', data?.payload?.data?.publishable_key)
      commit('updateSeamComponentUuid', data?.payload?.data?.uuid)
      commit(
        'updateClientSessionToken',
        data?.payload?.data?.client_session_token
      )
    },
    async toggleDeviceActive({ commit }, deviceId) {
      try {
        const response = await axios.post(
          `/api/iot/listing-devices/toggle-active`,
          {
            device_id: deviceId,
          }
        )
        return response.data
      } catch (error) {
        console.error('Error toggling device active status:', error)
        throw error
      }
    },
    async unmanageDevice({ commit, dispatch }, deviceId) {
      try {
        const response = await axios.post(`/api/iot/listing-devices/unmanage`, {
          device_id: deviceId,
        })
        await dispatch('getAllDevices')
        return response.data
      } catch (error) {
        console.error('Error unmanaging device:', error)
        Toaster.show([
          {
            type: 'error',
            text: 'Failed to unmanage device. Please try again.',
          },
        ])
        throw error
      }
    },
    async manageDevice({ commit, dispatch }, deviceId) {
      try {
        const response = await axios.post(`/api/iot/listing-devices/manage`, {
          device_id: deviceId,
        })
        await dispatch('getAllDevices')
        return response.data
      } catch (error) {
        console.error('Error managing device:', error)
        Toaster.show([
          {
            type: 'error',
            text: 'Failed to manage device. Please try again.',
          },
        ])
        throw error
      }
    },
  },
}
